import { makeStyles } from '@material-ui/core/styles';

// Shared look for the interstitial's inline text links.
const linkButton = (theme) => ({
  background: 'none',
  border: 'none',
  color: theme.colorPalette.orange_50,
  cursor: 'pointer',
  font: 'inherit',
  fontSize: 16,
  fontWeight: 600,
  lineHeight: '24px',
  padding: theme.spacing(2)
});

const styles = (theme) => ({
  // Interstitial step — mirrors Figma node 60535-49834: 580px beige modal, 48px padding,
  // centered 80px spinner, semibold copy, orange semibold text-button link.
  interstitialPaper: {
    alignItems: 'center',
    backgroundColor: theme.colors.modal__background_primary,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(6),
    justifyContent: 'center',
    padding: theme.spacing(12),
    textAlign: 'center',
    width: 580
  },
  spinner: {
    height: 80,
    width: 80
  },
  interstitialText: {
    color: theme.colorPalette.green_75,
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '24px'
  },
  // Both spinner-step affordances share one treatment: an orange semibold text link, never the
  // core Button, which renders boxy inline (staff-fe/AGENTS.md).
  interstitialActions: {
    display: 'flex',
    justifyContent: 'center'
  },
  loadNowLink: linkButton(theme),
  keepVersionLink: linkButton(theme),
  // Confirmation step — mirrors Figma node 60638-61327: 580px beige modal, 48px padding,
  // left-aligned copy under the alert illustration, actions bottom-right.
  confirmPaper: {
    backgroundColor: theme.colors.modal__background_primary,
    borderRadius: theme.sizes.roundCorners,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(8),
    padding: theme.spacing(12),
    width: 580
  },
  confirmContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(6)
  },
  confirmCopy: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4)
  },
  warningIcon: {
    alignSelf: 'flex-start',
    width: 40
  },
  confirmBody: {
    fontSize: 16,
    lineHeight: '24px'
  },
  confirmActions: {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'flex-end'
  }
});

export default makeStyles(styles);
